module.exports = "/next-static/_next/static/images/block_image_podcasts-1cca2dff9f184b3608ad3bef780a51d8.png";